import React, { useEffect, useState } from "react";
import MainBanner from "../../Components/Banner/MainBanner";
import Footer from "../../Components/Footer/Footer";
import Header from "../../Components/Header/Header";
import "../../assets/css/Camping.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { arrow, dollar } from "../../constant";
import Apple from "../../assets/img/booking/garder_town/apple.png";
import google from "../../assets/img/booking/garder_town/google.png";
// import paypal from "../../assets/img/booking/garder_town/paypal.png";
import mastercard from "../../assets/img/booking/garder_town/mastercard.png";
import visa from "../../assets/img/booking/garder_town/visacard.png";
import StripeForm from "../../Components/PaymentMethod/StripeForm";
import ActionButton from "../../Components/ActionBtn/ActionButton";
import {
	bookMemberShipPost,
	GetMembership,
	GetExtraCharges,
	GetMembershipBook,
	GetMembershipLocation,
	PostMembershipById,
	GetBookingDates,
} from "../../network/Network";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Skeleton from "react-loading-skeleton";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import GoogleMapComp from "../../Components/Map/GoogleMap";

function Camping() {
	const ImageUrlRedux = useSelector((state) => state.AuthReducer.urlData);
	const new_date = new Date().toISOString().slice(0, 10);
	const [campingMembership, setCampingMembership] = useState({});
	const [locationMemb, setLocationMemb] = useState(null);
	const [locationVal, setLocatinVal] = useState(null);
	const Token = useSelector((state) => state?.AuthReducer?.token);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [gardenMembership, setGardenMembership] = useState([]);
	const [camping, setCamping] = useState();
	const [state, setState] = useState({
		membership_id: 2,
		is_family_membership: "",
		other_memberships_included: "",
		price: gardenMembership?.price,
		booking_date: "",
		booking_time: "",
	});
	const [loading, setLoading] = useState(false);
	const [btnLoading, setBtnLoading] = useState(false);
	const [singleCamping, setSingleCamping] = useState();
	const [membershipId, setMembershipId] = useState();
	const styling = {
		marginTop: "10px",
		width: "100%",
	};

	const [checkBookingDates, setCheckBookingDates] = useState([]);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		if (state.other_memberships_included) {
			let value = camping?.filter((item) => {
				if (item?.type === "camping") return item;
			});
			setSingleCamping(value?.[0]);
		}
	}, [state.other_memberships_included]);

	// Get Membership by id
	useEffect(() => {
		setLoading(true);
		PostMembershipById(2)
			.then((res) => {
				setCampingMembership(res?.data);
				setLoading(false);
				// dispatch(AllCategoriesData(res?.data));
			})
			.catch((err) => {
				setLoading(false);
				// console.log(err);
			});
	}, []);

	useEffect(() => {
		setLoading(true);
		GetMembershipBook()
			.then((res) => {
				setCamping(res.data);
				setLoading(false);
				// setGardenMembership(res?.data);
			})
			.catch((err) => {
				setLoading(false);
				// console.log(err);
			});
	}, []);

	useEffect(() => {
		setLoading(true);
		GetMembershipLocation()
			.then((res) => {
				setLoading(false);
				setLocationMemb(res?.data?.response?.data);
				setLocatinVal(res.data.response.data[0].id);
			})
			.catch((err) => {
				setLoading(false);
				// console.log(err);
			});
	}, []);

	useEffect(() => {
		setLoading(true);
		GetExtraCharges()
			.then((res) => {
				setMembershipId(res.data);
				// console.log(res.data, "check membership");
				setLoading(false);
			})
			.catch((err) => {
				// console.log(err);
				setLoading(false);
			});
	}, []);

	const extractDate = (dateString) => {
		const regex = /[a-zA-Z]{3} [a-zA-Z]{3} \d{2} \d{4}/;
		const match = dateString?.toString()?.match(regex);
		const inputDate = new Date(match ? match[0] : "");
		const outputDate = `${inputDate.getFullYear()}-${
			inputDate.getMonth() + 1
		}-${inputDate.getDate()}`;
		return outputDate;
	};

	const PlaceOrderHandler = (e, stripe_token) => {
		e.preventDefault();
		setBtnLoading(false);
		if (!state?.booking_date || !state?.booking_time || !locationVal) {
			toast.error("Plese fill all compulsory fields");
			setBtnLoading(false);
		} else {
			const { membership_id, booking_date, booking_time } = state ?? {};
			let sendData = {
				membership_id: membership_id,
				// is_family_membership: state?.is_family_membership,
				// other_memberships_included: state?.other_memberships_included
				//   ? singleCamping?.id
				//   : null,
				other_memberships_included: state?.other_memberships_included ?? null,
				// price: state?.other_memberships_included ? `${parseInt(singleCamping?.price) + parseInt(campingMembership?.price)}` : campingMembership?.price,
				price: campingMembership?.price,
				_token: stripe_token,
				booking_date: extractDate(booking_date),
				booking_time: booking_time,
				farm_location_id: locationVal,
				type: "booking",
			};
			bookMemberShipPost(sendData, Token)
				.then((res) => {
					setBtnLoading(false);
					navigate("/");
					toast.success("Night Camping booking has been done successfully");
					GetBookingDates(campingMembership?.id, locationVal);
				})
				.catch((err) => {
					// toast.error("An error occured during booking");
					toast.error(`${err?.response?.data?.message}`);
					setBtnLoading(false);
					// navigate('/');
					// console.log(err);
				});
		}
	};

	const [mapData, setMapData] = useState();
	const FindLocation = (value = locationVal) => {
		let filterMapData = locationMemb?.filter((val) => val?.id == value);
		if (filterMapData?.length > 0) {
			setMapData(filterMapData[0]);
			// return filterMapData[0]
		}
	};

	useEffect(() => {
		FindLocation(locationVal);
	}, [locationVal]);

	useEffect(() => {
		const membershipId = 1,
			locationId = 1;
		setLoading(true);
		GetBookingDates(campingMembership?.id, locationVal)
			.then((res) => {
				const result = res?.data?.response?.data;
				const dates = result?.map((date) => {
					return date?.booking_date;
				});
				setCheckBookingDates(dates);
				setState({ ...state, booking_date: "" });
				setLoading(false);
			})
			.catch((err) => {
				setLoading(false);
			});
	}, [locationVal, campingMembership]);

	console.log(campingMembership, "campingMembership");

	// Define the array of disabled dates (replace this with your specific dates)
	// const disabledDates = ["2023-08-10", "2023-08-15", "2023-08-20"];

	// Function to check if a date is disabled
	// const isDateDisabled = (date = "") => {
	// 	const formattedDate = date.toISOString().split("T")[0]; // Convert date to "YYYY-MM-DD" format
	// 	return checkBookingDates.includes(formattedDate);
	// };

	// Function to check if a date should be disabled
	const isDateDisabled = (date = "") => {
		const formattedDate = date.toISOString().split("T")[0]; // Convert date to "YYYY-MM-DD" format
		return !checkBookingDates.includes(formattedDate);
		// return !checkBookingDates.some(
		// 	(disabledDate) =>
		// 		new Date(disabledDate).toDateString() === date.toDateString(),
		// );
	};

	return (
		<>
			<Header />
			<MainBanner name={"Camping"} />
			<section className="Camping-page">
				<div className="container">
					{loading ? (
						<Skeleton count={5} />
					) : (
						<div>
							<div className="Book_range_center">
								<h2 className="main-Title">Book 1 Night Camping </h2>
								<h3 className="priceRate">
									<img src={dollar} alt="" />
									{/* {?.price} */}
									{
										<span className="ml-2">
											{state?.other_memberships_included
												? `${
														parseInt(singleCamping?.price) +
														parseInt(campingMembership?.price)
												  }`
												: campingMembership?.price}
										</span>
									}
								</h3>
							</div>
							<p className="main-para">{campingMembership?.description}</p>
							<ActionButton />
							<div className="formContainer">
								<p className="sub-title">Booking Details</p>
								<div className="row">
									<div className="col-lg-6">
										<p className="sub-title-sm">Select the Date</p>
										{/* <input
                      min={new_date}
                      onKeyDown={(e) => e.preventDefault()}
                      onChange={(e) => {
                        setState({ ...state, booking_date: e.target.value });
                      }}
                      type="date"
                    /> */}
										{/* <DatePicker
											selected={state.booking_date}
											onChange={(date) => {
												if (!isDateDisabled(date)) {
													setState({ ...state, booking_date: date });
												}
											}}
											minDate={new_date}
											filterDate={!isDateDisabled} // This disables the specific dates in the calendar
											placeholderText={"dd/mm/yyyy"}
										/> */}

										<DatePicker
											selected={state.booking_date}
											onChange={(date) =>
												setState({ ...state, booking_date: date })
											}
											filterDate={isDateDisabled}
											dateFormat="MMMM d, yyyy"
											placeholderText={"mm, dd, yyyy"}
											minDate={new Date()}
										/>
									</div>
									<div className="col-lg-6">
										<p className="sub-title-sm">Select Check-in Time</p>
										<input
											onChange={(e) => {
												setState({ ...state, booking_time: e.target.value });
											}}
											type="time"
										/>
									</div>
									<div className="col-lg-6 addCampingRadio">
										<div className="row">
											{/* <div className="col-md-2 centerRadioBtn"></div> */}
											<div className="col-md-12">
												<p className="sub-title-sm with_check">
													{/* <input onChange={(e) => { setState({ ...state, other_memberships_included: e.target.checked }) }} type="checkbox" /> */}
													{/* <input
                            onChange={(e) => {
                              const gardenTourObj = membershipId.find(
                                (obj) => obj.type === "garden_tour"
                              );
                              const gardenTourId = gardenTourObj
                                ? gardenTourObj.id
                                : null;
                              setState({
                                ...state,
                                other_memberships_included: gardenTourId
                                  ? gardenTourId
                                  : e.target.checked,
                              });
                                if (e.target.checked && gardenTourId) {
                                  console.log(`ID: ${gardenTourId}`);
                                }
                            }}
                            type="checkbox"
                          /> */}
													<input
														onChange={(e) => {
															const gardenTourObj = membershipId.find(
																(obj) => obj.type === "garden_tour",
															);
															const gardenTourId = gardenTourObj
																? gardenTourObj.id
																: null;
															setState({
																...state,
																other_memberships_included: e.target.checked
																	? gardenTourId
																		? gardenTourId
																		: e.target.checked
																	: null,
															});
														}}
														type="checkbox"
														checked={state.other_memberships_included || false}
													/>

													<span>
														Add Garden tour to the package. (extra charges
														included)
													</span>
												</p>
											</div>
										</div>
									</div>
									<div className="col-lg-6">
										<p className="sub-title-sm">
											Select Camping location on farm
										</p>
										<select
											onChange={(e) => {
												setLocatinVal(e.target.value);
												FindLocation(e.target.value);
											}}
											defaultValue={locationVal}
										>
											{/* <option>Select Location</option> */}
											{locationMemb?.map((item, index) => {
												return (
													<option
														key={index + 8561}
														value={item.id}
														// {...(locationVal === item?.id ? "selected" : "")}
													>
														{item.name}
													</option>
												);
											})}
										</select>
									</div>
								</div>

								{locationVal ? (
									<div className="col-lg-12">
										<div style={{ height: "100px", width: "100%" }}>
											<GoogleMapComp
												mapData={mapData}
												locationVal={locationVal}
											/>
										</div>
									</div>
								) : null}

								{Token ? (
									<>
										<p className="sub-title">Payment Details </p>
										<StripeForm
											styling={styling}
											paynow="SUBMIT"
											PaymentHandler={PlaceOrderHandler}
											loading={btnLoading}
										/>
									</>
								) : (
									<>
										<p className="sub-title">Payment Details </p>
										<div className="camping_btn">
											<button
												onClick={() => {
													navigate("/login");
												}}
												className="btn"
											>
												Sign In
												<img src={arrow} className="image-fluid pl-2" />
											</button>
											<button
												onClick={() => {
													navigate("/signup");
												}}
												className="btn secondbtn"
											>
												Create An Account
												<img src={arrow} className="image-fluid pl-2" />
											</button>
										</div>
									</>
								)}
							</div>
						</div>
					)}
				</div>
			</section>
			<Footer />
		</>
	);
}

export default Camping;
